export interface RoleOption {
  id: string;
  label: string;
  peerGroup: string;
}

export const roleOptions: RoleOption[] = [
  { id: 'specialist', label: 'Fertility specialist / Reproductive endocrinologist', peerGroup: 'fellow fertility specialists' },
  { id: 'embryologist', label: 'Clinical embryologist', peerGroup: 'fellow clinical embryologists' },
  { id: 'nurse', label: 'Fertility nurse / Midwife', peerGroup: 'fellow fertility nurses and midwives' },
  { id: 'researcher', label: 'Researcher / Academic', peerGroup: 'fellow researchers and academics' },
  { id: 'other', label: 'Other fertility professional', peerGroup: 'fertility professionals' },
];

export const defaultPeerGroup = 'your peers';
